// a.k.a. collections (not the firebase ones).

import { GetQueryProps } from 'services/api/firestore';
import { DocumentData } from 'firebase/firestore';

export const COLORING_GRID_CATEGORIES_COLLECTION_PATH = 'coloringGridCollections';

export const ALL_COLORING_GRID_CATEGORIES_QUERY: GetQueryProps<DocumentData> = {
  collectionPath: COLORING_GRID_CATEGORIES_COLLECTION_PATH,
};
